import classNames from 'classnames';
import { type ReactNode } from 'react';

import OverlayTrigger from '../../../OverlayTrigger';
import Tooltip from '../../../Tooltip';

import styles from './_index.module.scss';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  'data-testid'?: string;
  icon?: ReactNode;
  isDisabled?: boolean;
  isSelected?: boolean;
  tooltip?: ReactNode;
}

const Button = ({
  children,
  className,
  'data-testid': dataTestId = 'rich-text-input-button',
  icon,
  isDisabled,
  isSelected,
  tooltip,
  ...props
}: ButtonProps) => {
  return (
    <OverlayTrigger.Tooltip overlay={tooltip && !isDisabled ? <Tooltip>{tooltip}</Tooltip> : <></>}>
      <button
        {...props}
        className={classNames(styles.button, className, {
          [styles['is-disabled']]: isDisabled,
          [styles['is-selected']]: isSelected,
        })}
        data-testid={dataTestId}
        disabled={isDisabled}
        type="button"
      >
        {icon && (
          <span aria-hidden className={styles['button-icon']}>
            {icon}
          </span>
        )}
        {children && <span className={styles['button-label']}>{children}</span>}
      </button>
    </OverlayTrigger.Tooltip>
  );
};

export default Button;
